import { FC, ReactNode } from "react";
import "./ButtonGroup.scss";

interface ButtonGroupProps {
  children: ReactNode;
}

const ButtonGroup: FC<ButtonGroupProps> = ({ children }) => {
  return <div className="button-group d-flex gap-2">{children}</div>;
};

export default ButtonGroup;
